export default __webpack_public_path__ + "static/media/Resume_darshan.56a13ab9.pdf";